import { BaseProgram, getColor } from '@wufe/particles';
import quadTreeVertexShader from './shaders/quadtree.vert';
import quadTreeFragmentShader from './shaders/quadtree.frag';
var Attr;
(function (Attr) {
    Attr["POSITION"] = "v_pos";
})(Attr || (Attr = {}));
var Uni;
(function (Uni) {
    Uni["COLOR"] = "v_col";
})(Uni || (Uni = {}));
export class QuadTreeProgram extends BaseProgram {
    constructor(gl, viewBox, libraryInterface, _params) {
        super(gl, quadTreeVertexShader, quadTreeFragmentShader, Object.values(Attr), Object.values(Uni), viewBox, libraryInterface);
        this._params = _params;
        this._strideLength = 3;
    }
    _getQuadTree() {
        return this._libraryInterface.getProximityDetectionSystem().quadTree;
    }
    init() {
        super.init();
        const [r, g, b, a] = this._params.color;
        this._color = new Float32Array(getColor(r, g, b, a));
        this._vectorsBuffer = this._gl.createBuffer();
        this._updateQuadTree();
    }
    _updateQuadTree() {
        const quadTree = this._getQuadTree();
        this._quadTree = quadTree;
        this._buildVertices();
    }
    update(deltaT, T) {
        super.update(deltaT, T);
        this._updateQuadTree();
    }
    _buildVertices() {
        const boundaries = this._getBoundariesFromQuadTree(this._quadTree);
        this._vertices = new Float32Array(boundaries.map(({ position, dimensions }) => [
            // topLeftFront
            position.x - dimensions.x, position.y + dimensions.y, position.z + dimensions.z,
            // topRightFront
            position.x + dimensions.x, position.y + dimensions.y, position.z + dimensions.z,
            // topRightFront
            position.x + dimensions.x, position.y + dimensions.y, position.z + dimensions.z,
            // bottomRightFront
            position.x + dimensions.x, position.y - dimensions.y, position.z + dimensions.z,
            // bottomRightFront
            position.x + dimensions.x, position.y - dimensions.y, position.z + dimensions.z,
            // bottomLeftFront
            position.x - dimensions.x, position.y - dimensions.y, position.z + dimensions.z,
            // bottomLeftFront
            position.x - dimensions.x, position.y - dimensions.y, position.z + dimensions.z,
            // topLeftFront
            position.x - dimensions.x, position.y + dimensions.y, position.z + dimensions.z,
            // topLeftBack
            position.x - dimensions.x, position.y + dimensions.y, position.z - dimensions.z,
            // topRightBack
            position.x + dimensions.x, position.y + dimensions.y, position.z - dimensions.z,
            // topRightBack
            position.x + dimensions.x, position.y + dimensions.y, position.z - dimensions.z,
            // bottomRightBack
            position.x + dimensions.x, position.y - dimensions.y, position.z - dimensions.z,
            // bottomRightBack
            position.x + dimensions.x, position.y - dimensions.y, position.z - dimensions.z,
            // bottomLeftBack
            position.x - dimensions.x, position.y - dimensions.y, position.z - dimensions.z,
            // bottomLeftBack
            position.x - dimensions.x, position.y - dimensions.y, position.z - dimensions.z,
            // topLeftBack
            position.x - dimensions.x, position.y + dimensions.y, position.z - dimensions.z,
            // topLeftFront
            position.x - dimensions.x, position.y + dimensions.y, position.z + dimensions.z,
            // topLeftBack
            position.x - dimensions.x, position.y + dimensions.y, position.z - dimensions.z,
            // topRightFront
            position.x + dimensions.x, position.y + dimensions.y, position.z + dimensions.z,
            // topRightBack
            position.x + dimensions.x, position.y + dimensions.y, position.z - dimensions.z,
            // bottomRightFront
            position.x + dimensions.x, position.y - dimensions.y, position.z + dimensions.z,
            // bottomRightBack
            position.x + dimensions.x, position.y - dimensions.y, position.z - dimensions.z,
            // bottomLeftFront
            position.x - dimensions.x, position.y - dimensions.y, position.z + dimensions.z,
            // bottomLeftBack
            position.x - dimensions.x, position.y - dimensions.y, position.z - dimensions.z,
        ]).flat());
    }
    _getBoundariesFromQuadTree(root, boundaries = []) {
        boundaries.push(root.boundary);
        for (const quadrant of Object.values(root.getQuadrants())) {
            this._getBoundariesFromQuadTree(quadrant, boundaries);
        }
        return boundaries;
    }
    draw(deltaT, T) {
        super.draw(deltaT, T);
        this._gl.uniform4fv(this.uni(Uni.COLOR), this._color);
        this._gl.enableVertexAttribArray(this.attr(Attr.POSITION));
        this._gl.bindBuffer(this._gl.ARRAY_BUFFER, this._vectorsBuffer);
        this._gl.bufferData(this._gl.ARRAY_BUFFER, this._vertices, this._gl.STATIC_DRAW);
        this._gl.vertexAttribPointer(this.attr(Attr.POSITION), 3, this._gl.FLOAT, false, this._strideLength * Float32Array.BYTES_PER_ELEMENT, 0);
        this._gl.bindBuffer(this._gl.ARRAY_BUFFER, null);
        this._gl.drawArrays(this._gl.LINES, 0, this._vertices.length / this._strideLength);
        this._gl.disableVertexAttribArray(this.attr(Attr.POSITION));
    }
}
